// Helper function to pluralize words based on count
export function pluralize(count: number, singular: string, plural?: string): string {
  if (count === 1) {
    return `${singular}`
  }
  return `${plural || `${singular}s`}`
}

// Helper function to determine "has" or "have" based on count
export function hasHave(count: number): string {
  return count === 1 ? 'has' : 'have'
}

// Helper function to format a date in full month format (e.g., "May 25, 2016")
export function fullMonthDate(date: Date | string, omitCurrentYear = false): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date

  // Check if the date is valid
  if (isNaN(dateObj.getTime())) {
    throw new Error('Invalid date provided to fullMonthDate')
  }

  const currentYear = new Date().getFullYear()

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
  }

  if (!omitCurrentYear || dateObj.getFullYear() !== currentYear) {
    options.year = 'numeric'
  }

  return dateObj.toLocaleDateString('en-US', options)
}

export function createRelativeTimeProps(
  time: Date | string,
  className?: string,
): {
  datetime: string
  className: string
  children: string
} {
  const dateObj = typeof time === 'string' ? new Date(time) : time
  const displayText = fullMonthDate(dateObj)
  const isoDateTime = dateObj instanceof Date && !isNaN(dateObj.getTime()) ? dateObj.toISOString() : ''
  const classes = ['no-wrap', className].filter(Boolean).join(' ')

  return {
    datetime: isoDateTime,
    className: classes,
    children: displayText,
  }
}
